var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.telemetry2.truck.ignitionIsTurnedOn)?_c('div',{staticClass:"gauge-display d-flex justify-content-center align-items-center flex-column"},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }